import { Box, Button, TableCell, TableRow, Typography } from "@mui/material";
import React, { useState } from "react";
import { ImageContainer } from "../../../../shared/components/ImageContainer";
import { EditIcon, TrashIcon } from "../../../../assets/icons/icons";

import DeleteDialog from "../../../products/product/DeleteDialog";

import {
  capitalizeFirstLetter,
  monthStringFormatDate,
} from "../../../../utils/extensions";

import { useGlobalContext } from "../../../../App";
import { updateStudioContent } from "../../../../services/studioContent";

interface tableRowProps {
  row: any;
  setIsEditDialogVisible?: any;
}

const Row: React.FC<tableRowProps> = ({ row, setIsEditDialogVisible }) => {
  const { studioContentData } = useGlobalContext();

  const [isDeleteDialogVisible, setIsDeleteDialogVisible] = useState(false);

  const handleEdit = (row: any) => {
    setIsEditDialogVisible(row);
  };

  const handleDeleteProject = async () => {
    const allProjects = studioContentData?.projects;
    //Exclude this current row from all projects
    const updatedProjects = allProjects.filter(
      (item: any) => item._id !== row?._id
    );

    //deleting is same as updating in api
    const data = {
      isUpdatingStudioProjects: true,
      updatedProjects: updatedProjects,
      studioContentId: studioContentData?._id,
    };

    await updateStudioContent(data)
      .then((res) => console.log("deleted successfully"))
      .catch((err) => {
        console.log("error deleting project");
      });

    setIsDeleteDialogVisible(false);
  };

  return (
    <TableRow
      onClick={() => {}}
      sx={{
        cursor: "pointer",
        ":hover": {
          bgcolor: "rgba(255, 255, 255, 0.06) !important",
        },
      }}
      hover
      role="checkbox"
      tabIndex={-1}
      key={row?.id}
    >
      {/* Image with title and checkbox  */}
      <TableCell
        sx={{
          width: "350px",
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          {row?.imageUrl && (
            <Box
              sx={{
                display: "flex",
                aspectRatio: "104/72",
                justifyContent: "center",
                alignItems: "center",
                width: "104px",
                height: "72px",
                borderRadius: "3px",
              }}
            >
              <img
                style={{
                  width: "104px",
                  height: "72px",
                  borderRadius: "3px",
                }}
                alt="cover"
                src={row?.imageUrl}
              />
            </Box>
          )}
          <Box sx={{ display: "flex", gap: "6px" }}>
            <Typography
              sx={{ color: "white", fontWeight: "300" }}
              variant="body2"
            >
              {row?.title || "-"}
            </Typography>
          </Box>
        </Box>
      </TableCell>

      {/* Category  */}
      <TableCell
        sx={{
          // width: "140px",
          flex: 1,
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Typography sx={{ color: "white", fontWeight: "300" }} variant="body2">
          {row?.description ? row?.description : "-"}
        </Typography>
      </TableCell>

      {/* Collection  */}
      <TableCell
        sx={{
          // width: "140px",
          flex: 1,
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Typography sx={{ color: "white", fontWeight: "300" }} variant="body2">
          {row?.link ? row?.link : "-"}
        </Typography>
      </TableCell>

      {/* Date edited  */}
      <TableCell
        sx={{
          // width: "140px",
          flex: 1,
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Typography sx={{ color: "white", fontWeight: "300" }} variant="body2">
          {row?.createdAt ? monthStringFormatDate(row?.createdAt) : "-"}
        </Typography>
      </TableCell>

      {/* Action buttons  */}
      <TableCell
        sx={{
          maxWidth: "80px",
          minWidth: "80px",
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <Button
            onClick={() => {
              handleEdit(row);
            }}
            sx={{
              minWidth: "0px",
              minHeight: "0px",
              lineHeight: "0px",
              ":hover": {
                bgcolor: "none !important",
              },
            }}
          >
            <ImageContainer
              style={{ width: "24px", height: "24px" }}
              title={"edit"}
            >
              {EditIcon}
            </ImageContainer>
          </Button>

          <Button
            onClick={() => {
              setIsDeleteDialogVisible(true);
            }}
            sx={{
              minWidth: "0px",
              minHeight: "0px",
              lineHeight: "0px",
            }}
          >
            <ImageContainer
              style={{ width: "24px", height: "24px" }}
              title="trash"
            >
              {TrashIcon}
            </ImageContainer>
          </Button>
        </Box>

        {isDeleteDialogVisible && (
          <DeleteDialog
            title="Are you sure you want to delete the project?"
            setIsDeleteDialogVisible={setIsDeleteDialogVisible}
            deleteAction={() => {
              handleDeleteProject();
            }}
          />
        )}
      </TableCell>
    </TableRow>
  );
};

export default Row;
